import { ValueOf } from '@/types/util';

export const ETransactionDetailType = {
  COUNTER_CHARGE: '店頭チャージ',
  CVS_CHARGE: 'コンビニチャージ',
  DIRECT_BANK_CHARGE: '銀行口座チャージ',
  CREDIT_CARD_CHARGE: 'クレジットカードチャージ',
  CHARGE_CANCEL: 'チャージ取消',
  DIRECT_BANK_PURCHASE_GIFT: '銀行口座商品券購入',
  CREDIT_CARD_PURCHASE_GIFT: 'クレジットカード商品券購入',
  PREPAID_SETTLEMENT: 'プリペイド決済',
  DIRECT_BANK_SETTLEMENT: '銀行口座ダイレクト決済',
  CREDIT_CARD_SETTLEMENT: 'クレジットカード決済',
  SETTLEMENT_CANCEL: '決済取消',
  CAMPAIGN_GRANT: 'キャンペーン付与',
  CAMPAIGN_GRANT_CANCEL: 'キャンペーン付与取消',
  CAMPAIGN_GRANT_SCHEDULED: 'キャンペーン付与予定',
  CAMPAIGN_GRANT_SCHEDULE_CANCELED: 'キャンペーン付与予定取消',
  BULK_GRANT: '一括付与',
  BULK_GRANT_CANCEL: '一括付与取消',
  BALANCE_ADJUSTMENT_IN: '残高調整（加算）',
  BALANCE_ADJUSTMENT_OUT: '残高調整（減算）',
  BALANCE_EXPIRED: '残高失効',
  RECEIVE_GIFT: '商品券受取',
  CVS_PURCHASE_GIFT: 'コンビニ商品券購入',
  PURCHASE_GIFT_CANCEL: '商品券購入取消',
  CREDIT_AUTO_CHARGE: 'クレジットカードオートチャージ',
  BANK_AUTO_CHARGE: '銀行口座オートチャージ',
} as const;

export type TransactionDetailTypeKey = keyof typeof ETransactionDetailType;
export type TransactionDetailTypeValue = ValueOf<typeof ETransactionDetailType>;

export const transactionDetailTypeKeys = Object.keys(ETransactionDetailType) as TransactionDetailTypeKey[];

/** v-select用items */
export const transactionDetailTypeItems = transactionDetailTypeKeys
  .map((key) => ({
    title: ETransactionDetailType[key],
    value: key,
  }));
